/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NumberInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function NumberInput({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/NumberInput",
  onChange,
  isInvalid,
  size,
  disabled,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0
  
}) {
let questionAnswerValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer',
})
let questionAnswerIsValidData = fromData.useDataIsValid({ viewPath,
context: 'question',
path: 'answer',
validate: fromValidate.textInput,
})
let questionAnswerChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'answer',
})
let questionNameValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="number"
 data="question.answer"
 validate="/Data/validate.js textInput"
 onChange={questionAnswerChangeData}
 value={questionAnswerValueData}
 isInvalid={!questionAnswerIsValidData}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 data="question.name"
 text={questionNameValueData}
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}